import React, { useEffect, useState, useContext, Suspense } from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import AppRoutes from "./route/AppRoutes";
import { ImageCropContextProvider } from "./services/utils/imageCrop";
import Layout from "./theme/default/Layout";
import {
  cleanQueryParams,
  getAuthProfile,
  isArray,
} from "./services/utils/validation";
import { LanguageResProvider } from "./services/Context/LanguageContext";
import { useLayoutEffect } from "react";
import { getSearchParams } from "./services/utils/validation";
import { useAccountSettings } from "./services/Context/AccSettingContext";
import { useAnalytics } from "./services/analytics/useAnalytics";
import { AppointmentProvider } from "./services/Context/AppointmentFlowContext";
import { MessageProvider } from "./services/Context/MessageContext";
import PageLoader from "./services/utils/PageLoader";

export default function App() {
  const [applicationRoutes, setApplicationRoutes] = useState([]);
  const [islogin, setIslogin] = useState(
    /security\/(forgotpassword|login|resetpassword|passwordsuccess|passowrdfailed)/gm.test(
      window.location.pathname.toLowerCase(),
    ),
  );
  const [isDocViewer, setIsDocViewer] = useState(false);
  const location = useLocation();
  const { account, errMsg } = useAccountSettings();
  useAnalytics();

  const initAccount = (data) => {
    try {
      const app_routes = [...AppRoutes];
      const _defaultPage = data?.portalSettings?.find(
        (obj) => obj.code === "DFP",
      );
      if (_defaultPage?.value?.toUpperCase() == "SGI") {
        app_routes[0].element = (
          <Navigate
            to={
              getAuthProfile.getProfileAuth() ? "/dashboard" : "/security/login"
            }
            replace
          />
        );
      }
      setApplicationRoutes(app_routes);
    } catch (e) {
      console.log(e);
    }
  };

  useLayoutEffect(() => {
    if (isArray(errMsg)) {
      localStorage.setItem("errorMsg", JSON.stringify(errMsg));
    }
  }, [errMsg]);

  useLayoutEffect(() => {
    if (account) {
      const fetchData = async () => {
        try {
          await initAccount(account);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  }, [account]);

  useEffect(() => {
    const _isExternal = getSearchParams("isexternal");
    window.scrollTo(0, 0);

    if (location.pathname.includes("security")) {
      setIslogin(true);
    } else {
      setIslogin(false);
    }

    if (
      location.pathname.includes("docviewer") ||
      location.pathname.includes("pagenotfound") ||
      _isExternal ||
      location.pathname.includes("are-you-human") ||
      location.pathname.includes("session")
    ) {
      setIsDocViewer(true);
    } else {
      setIsDocViewer(false);
    }

    const timerId = setTimeout(() => {
      cleanQueryParams();
    }, 1000);

    return () => clearTimeout(timerId);
  }, [location]);

  useEffect(() => {
    setTimeout(() => {
      const links = document.querySelectorAll('a[target="_blank"]');
      links.forEach((link) => {
        if (!link.hasAttribute("rel")) {
          link.setAttribute("rel", "noopener noreferrer");
        }
      });
    }, 20000);
  }, []);

  // Shown while the route table is still empty and while a lazy route loads.
  const pageLoader = <PageLoader />;

  return (
    <LanguageResProvider>
      <ImageCropContextProvider>
        <AppointmentProvider>
          <MessageProvider>
            <Layout islogin={islogin} isViewer={isDocViewer}>
              <Suspense fallback={pageLoader}>
                {isArray(applicationRoutes) ? (
                  <Routes>
                    {applicationRoutes.map((route, index) => {
                      const { element, ...rest } = route;
                      return (
                        <Route key={index} {...rest} element={element} />
                      );
                    })}
                  </Routes>
                ) : (
                  pageLoader
                )}
              </Suspense>
            </Layout>
          </MessageProvider>
        </AppointmentProvider>
      </ImageCropContextProvider>
    </LanguageResProvider>
  );
}
